import {
	NumberFormatter as MantineNumberFormatter,
	NumberFormatterProps as MantineNumberFormatterProps,
} from '@mantine/core';
import clsx from 'clsx';

export const NumberFormatter = ({ className, ...props }: MantineNumberFormatterProps) => (
	<MantineNumberFormatter
		className={clsx('mantine-NumberFormatter-root', 'native', className)}
		{...props}
	/>
);
